import {Dispatch, memo, MutableRefObject} from 'react';

import {Form} from 'react-final-form';

import FormField from '~/shared/components/FormField';
import {
  FieldWrapper,
  FormWrapper,
  LoginFormFieldsWrapper,
  HeaderText,
  StyledErrorText,
} from '~/shared/components/loginStyled';
import FormPieInput from '~/shared/components/FormField/FormInput/FormPieInput';
import PieButton from '~/shared/theme/pie/PieButton';
import {getLocalizationService} from '~/shared/services/localisationService';

import OAuthSection from '../OAuthSection';
import {LoginProvider, ViewModes} from '../consts';

type LoginFormProps = {
  onSubmitEmail: (args: {
    email: string;
    shouldSendTrackEvent?: boolean;
  }) => Promise<void>;
  loginProvider: LoginProvider;
  initialValues: {email: string};
  resErrors: string | null;
  setResErrors: Dispatch<string | null>;
  openProviderScreen: (args: {
    providerProps: Record<string, string | number | undefined>;
    nextLoginProvider: LoginProvider;
    nextScreen: ViewModes;
  }) => void;
  openLoginScreen: (args?: {
    email?: string;
    getAuthCodeForProviderConnect?: boolean;
    providerProps?: Record<string, string | number | undefined>;
  }) => Promise<void>;
  isRedirectedToStepRef: MutableRefObject<boolean>;
  fromCheckout?: boolean;
  onSubmitWithGoogleConnect: () => void;
};

const LoginForm = ({
  onSubmitEmail,
  loginProvider,
  initialValues,
  resErrors,
  setResErrors,
  openProviderScreen,
  openLoginScreen,
  isRedirectedToStepRef,
  fromCheckout,
  onSubmitWithGoogleConnect,
}: LoginFormProps) => {
  const {t} = getLocalizationService();

  return (
    <>
      <Form
        onSubmit={onSubmitEmail}
        initialValues={initialValues}
        validateOnBlur
        render={({handleSubmit}) => (
          <FormWrapper onSubmit={handleSubmit}>
            <HeaderText id="modal-title">{t('login_form_header')}</HeaderText>
            <LoginFormFieldsWrapper>
              <FieldWrapper>
                {/* @ts-expect-error FormField should be rewritten to TypeScript  */}
                <FormField
                  {...{
                    name: 'email',
                    placeholder: t('what_is_your_email'),
                    type: 'email',
                    required: true,
                    requiredErrorText: 'we_need_an_email_to_get_things_moving',
                    render: FormPieInput,
                    isPieStyle: true,
                    inputProps: {
                      autoComplete: 'email',
                      onKeyUp: () => {
                        if (!resErrors) {
                          return;
                        }

                        setResErrors(null);
                      },
                    },
                    className: 'white-border-on-contrast',
                  }}
                />
              </FieldWrapper>
              {resErrors && <StyledErrorText>{resErrors}</StyledErrorText>}
            </LoginFormFieldsWrapper>
            <PieButton
              variant="primaryLarge"
              data-test-id="login-submit"
              type="submit"
            >
              {t('lets_go')}
            </PieButton>
          </FormWrapper>
        )}
      />
      {
        loginProvider === LoginProvider.TENBIS && (
          <OAuthSection
            onSubmitWithGoogleConnect={onSubmitWithGoogleConnect}
            openProviderScreen={openProviderScreen}
            openLoginScreen={openLoginScreen}
            isRedirectedToStepRef={isRedirectedToStepRef}
            fromCheckout={fromCheckout}
          />
        )
      }
    </>
  );
};

export default memo(LoginForm);
